module.exports = "<ng-container *ngIf=\"!isLoading; else elseblock\">\r\n  <ng-container *ngIf=\"tipo === 'IFRAME' || tipo === 'LINK'\">\r\n    <app-metadata-form></app-metadata-form>\r\n  </ng-container>\r\n</ng-container>\r\n<ng-template #elseblock>\r\n  Caricamento dati in corso...\r\n</ng-template>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/utils/item-manager/metadata-blocco/metadata-blocco.component.html
// module id = ../../../../../src/app/components/utils/item-manager/metadata-blocco/metadata-blocco.component.html
// module chunks = main